module.exports = __webpack_public_path__ + "img/factorytitle.0bd776af.png";